import script from "./AccountCreationConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountCreationConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./AccountCreationConfirmModal.vue?vue&type=style&index=0&id=06f0c3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f0c3ba"]])

export default __exports__